import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty, CopyButton } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ChangePassword } from "@/components/ChangePassword";

export default function Settings() {
  const { user, refresh } = useAuth();
  const m = user?.merchant || {};
  const [form, setForm] = useState({ name: m.name || "", confirmations_required: m.confirmations_required ?? "", order_ttl_minutes: m.order_ttl_minutes ?? "" });
  const [defaults, setDefaults] = useState(null);
  const [logs, setLogs] = useState([]);
  const [store, setStore] = useState(null);
  useEffect(() => { api.get("/merchant/settings").then((r) => setDefaults(r.data)); api.get("/merchant/audit-logs").then((r) => setLogs(r.data)); api.get("/merchant/store").then((r) => setStore(r.data)); }, []);

  const saveStore = async (patch) => {
    try { const { data } = await api.patch("/merchant/store", patch); setStore(data); toast.success("Vitrine mise à jour"); }
    catch (e2) { toast.error(errMsg(e2)); }
  };

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.patch("/merchant/me", { name: form.name, confirmations_required: form.confirmations_required === "" ? undefined : Number(form.confirmations_required), order_ttl_minutes: form.order_ttl_minutes === "" ? undefined : Number(form.order_ttl_minutes) });
      await refresh(); toast.success("Réglages enregistrés");
    } catch (e2) { toast.error(errMsg(e2)); }
  };

  return (
    <div>
      <PageHeader title="Réglages" subtitle="Confirmations requises et durée de validité par marchand (sinon valeurs globales du super-admin)." />
      <form onSubmit={save} className="panel p-5 grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="space-y-1.5"><Label>Nom de la boutique</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="settings-name-input" /></div>
        <div className="space-y-1.5"><Label>Confirmations requises {defaults && <span className="text-zinc-500">(défaut {defaults.confirmations})</span>}</Label><Input type="number" min="0" max="6" value={form.confirmations_required} onChange={(e) => setForm({ ...form, confirmations_required: e.target.value })} data-testid="settings-confirmations-input" /></div>
        <div className="space-y-1.5"><Label>Validité commande (min) {defaults && <span className="text-zinc-500">(défaut {defaults.order_ttl_minutes})</span>}</Label><Input type="number" min="5" max="120" value={form.order_ttl_minutes} onChange={(e) => setForm({ ...form, order_ttl_minutes: e.target.value })} data-testid="settings-ttl-input" /></div>
        <div className="sm:col-span-3"><Button type="submit" className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="settings-save-button">Enregistrer</Button></div>
      </form>
      {store && (
        <div className="panel p-5 mb-8" data-testid="store-settings">
          <div className="flex items-center justify-between gap-4 mb-3">
            <div><div className="eyebrow mb-1">Vitrine publique</div><p className="text-xs text-zinc-400">Page listant tous vos produits actifs avec leurs liens de paiement. Partagez-la telle quelle.</p></div>
            <Switch checked={store.store_enabled} onCheckedChange={(v) => saveStore({ store_enabled: v })} data-testid="store-enabled-switch" />
          </div>
          <div className="mono-box flex items-center justify-between gap-2 mb-3"><a href={store.store_url} target="_blank" rel="noreferrer" className="hover:underline" data-testid="store-url">{store.store_url}</a><CopyButton value={store.store_url} label="Lien de la vitrine copié" testId="copy-store-url" /></div>
          <div className="flex gap-2">
            <Input placeholder="Description affichée en haut de la vitrine (facultatif)" defaultValue={store.store_description || ""} onBlur={(e) => e.target.value !== (store.store_description || "") && saveStore({ store_description: e.target.value })} data-testid="store-description-input" />
          </div>
        </div>
      )}
      <ChangePassword />
      <div className="eyebrow mb-3">Journal d'audit de votre compte</div>
      {logs.length === 0 ? <Empty text="Aucune action enregistrée." /> : (
        <div className="panel divide-y divide-border" data-testid="merchant-audit-logs">
          {logs.map((l) => <div key={l.id} className="p-3 text-xs flex justify-between gap-4"><span className="font-mono text-amber-400">{l.action}</span><span className="text-zinc-400 truncate">{JSON.stringify(l.details)}</span><span className="text-zinc-500 whitespace-nowrap">{fmtDate(l.created_at)}</span></div>)}
        </div>
      )}
    </div>
  );
}
